export default "__VITE_ASSET__BBCTpdWG__"